import React from 'react'
import { CardContent, Typography, Box, InputAdornment } from '@mui/material'
import { formatCurrency } from '../../../utils'
import { CardBox, CardBoxTopBar } from '../../../theme/styleComponents'
import { flexJustifySpaceBetween } from '../../../theme/styleConstants'
import { CustomController } from '../../common/CustomController'
import { FetchQuickBillDetailsQuery } from '../../../../generated'

interface NetTotalSectionProps {
  litigation?: FetchQuickBillDetailsQuery['fetchQuickBillDetails']['case']
  netTotal: number
}

const NetTotalSection: React.FC<NetTotalSectionProps> = ({ litigation, netTotal }) => {
  return (
    <CardBox mb={3}>
      <CardBoxTopBar sx={{ ...flexJustifySpaceBetween }}>
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          Discount
        </Typography>
        <CustomController
          controllerLabel="Discount"
          controllerName="discountPercentage"
          fullWidth={false}
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          sx={{ my: 0 }}
        />
      </CardBoxTopBar>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ ...flexJustifySpaceBetween, alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
            Net Total
          </Typography>
          <Typography variant="h5" fontWeight={600} fontSize="22px">
            {formatCurrency(netTotal)}
          </Typography>
        </Box>
      </CardContent>
    </CardBox>
  )
}

export default NetTotalSection
